import emailjs from '@emailjs/browser';

// Configuration EmailJS pour KSL
const KSL_EMAIL_CONFIG = {
  // Vos paramètres SMTP
  smtp: {
    host: 'mail.katianlogistique.com',
    port: 465,
    secure: true,
    user: 'contact@katianlogistique.com',
    pass: 'contact@katianlogistique.com.@'
  },
  // Configuration EmailJS (à configurer sur emailjs.com)
  serviceId: 'service_ksl_contact',
  templateId: 'template_contact',
  publicKey: 'YOUR_PUBLIC_KEY', // Remplacez par votre clé publique EmailJS
  fromName: 'KSL - Katian Logistique',
  toEmail: 'contact@katianlogistique.com'
};

// Service d'envoi d'email KSL
export const kslEmailService = {
  // Initialiser EmailJS
  init: () => {
    try {
      emailjs.init(KSL_EMAIL_CONFIG.publicKey);
      console.log('✅ EmailJS initialisé pour KSL');
    } catch (error) {
      console.error('❌ Erreur initialisation EmailJS:', error);
    }
  },

  // Envoyer un email de contact
  sendContactEmail: async (contactData) => {
    try {
      console.log('📧 [kslEmailService.sendContactEmail] → Envoi email KSL:', contactData);
      
      // Initialiser EmailJS
      kslEmailService.init();
      
      // Préparer les paramètres du template
      const templateParams = {
        // Informations du client
        from_name: contactData.name,
        from_email: contactData.email,
        phone: contactData.phone || 'Non fourni',
        company: contactData.company || 'Non fourni',
        subject: contactData.subject,
        message: contactData.message,
        
        // Configuration de destination
        to_email: KSL_EMAIL_CONFIG.toEmail,
        reply_to: contactData.email,
        
        // Métadonnées
        timestamp: new Date().toLocaleString('fr-FR'),
        website: 'https://katianlogistique.com',
        
        // Configuration SMTP (pour le template)
        smtp_host: KSL_EMAIL_CONFIG.smtp.host,
        smtp_port: KSL_EMAIL_CONFIG.smtp.port,
        smtp_user: KSL_EMAIL_CONFIG.smtp.user
      };

      // Envoyer l'email via EmailJS
      const response = await emailjs.send(
        KSL_EMAIL_CONFIG.serviceId,
        KSL_EMAIL_CONFIG.templateId,
        templateParams
      );

      console.log('✅ Email KSL envoyé:', response);
      
      // Envoyer l'email de confirmation au client
      await kslEmailService.sendConfirmationEmail(contactData);
      
      return {
        success: true,
        message: 'Email envoyé avec succès',
        emailId: response.text,
        timestamp: new Date().toISOString(),
        method: 'EmailJS'
      };
      
    } catch (error) {
      console.error('❌ Erreur envoi email KSL:', error);
      
      // Fallback: Utiliser une méthode alternative
      try {
        return await kslEmailService.sendViaFormspree(contactData);
      } catch (fallbackError) {
        console.error('❌ Erreur fallback Formspree:', fallbackError);
        throw new Error(`Erreur lors de l'envoi de l'email: ${error.message}`);
      }
    }
  },

  // Méthode de fallback avec Formspree
  sendViaFormspree: async (contactData) => {
    try {
      console.log('📧 [kslEmailService.sendViaFormspree] → Fallback Formspree');
      
      // Configuration Formspree (gratuit, 50 emails/mois)
      const formspreeEndpoint = 'https://formspree.io/f/xpwgkqyz'; // Remplacez par votre endpoint
      
      const formData = new FormData();
      formData.append('name', contactData.name);
      formData.append('email', contactData.email);
      formData.append('phone', contactData.phone || 'Non fourni');
      formData.append('company', contactData.company || 'Non fourni');
      formData.append('subject', contactData.subject);
      formData.append('message', contactData.message);
      formData.append('_replyto', contactData.email);
      formData.append('_subject', `Contact KSL - ${contactData.subject}`);
      formData.append('_cc', KSL_EMAIL_CONFIG.toEmail);

      const response = await fetch(formspreeEndpoint, {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error(`Erreur Formspree: ${response.status}`);
      }

      const result = await response.json();
      console.log('✅ Email envoyé via Formspree:', result);
      
      return {
        success: true,
        message: 'Email envoyé via Formspree',
        emailId: result.id || `formspree_${Date.now()}`,
        timestamp: new Date().toISOString(),
        method: 'Formspree'
      };
      
    } catch (error) {
      console.error('❌ Erreur Formspree:', error);
      throw error;
    }
  },

  // Envoyer un email de confirmation au client
  sendConfirmationEmail: async (contactData) => {
    try {
      console.log('📧 [kslEmailService.sendConfirmationEmail] → Envoi confirmation');
      
      // Utiliser un template de confirmation différent
      const confirmationParams = {
        to_name: contactData.name,
        to_email: contactData.email,
        subject: contactData.subject,
        timestamp: new Date().toLocaleString('fr-FR'),
        company_name: 'KSL - Katian Logistique',
        support_phone: '+225 01 60 00 55 55',
        support_email: 'contact@katianlogistique.com',
        website_url: 'https://katianlogistique.com'
      };

      const response = await emailjs.send(
        KSL_EMAIL_CONFIG.serviceId,
        'template_confirmation', // Template de confirmation
        confirmationParams
      );

      console.log('✅ Email de confirmation envoyé:', response);
      
      return {
        success: true,
        message: 'Email de confirmation envoyé',
        emailId: response.text,
        timestamp: new Date().toISOString()
      };
      
    } catch (error) {
      console.error('❌ Erreur envoi confirmation:', error);
      // Ne pas faire échouer l'envoi principal si la confirmation échoue
      return {
        success: false,
        message: 'Confirmation non envoyée',
        error: error.message
      };
    }
  }
};

export default kslEmailService;
